import { JSX, PropsWithChildren } from 'react';

import { EPermissions } from '@/types/permissions.types';
import useHasPermission from '@/utils/authentication/use-has-permission';

interface AuthWrapperProps {
  allowedRoles?: EPermissions[];
  blockedRoles?: EPermissions[];
}

export default function AuthWrapper({
  allowedRoles = [],
  blockedRoles = [],
  children,
}: PropsWithChildren<AuthWrapperProps>): JSX.Element {
  const { hasPermission } = useHasPermission({ allowedRoles, blockedRoles });

  if (hasPermission) {
    return <>{children}</>;
  }

  return <></>;
}
